import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi"

export const addStartupValoration = async (formValues, succesMsg, errorMsg, navigate) => {

    try {

        const { data } = await faradayApi.post('/startupValoration', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate('/startup')
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}

export const deleteStartupValoration = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm ) => {
    const {value} = await Swal.fire({
        text: `${deleteConfirm} ${e.startupName} - ${e.valuationDate}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
      })

    value && onConfirm(e.id, succesMsg, errorMsg, e.startupName)
}

const onConfirm = async (id, succesMsg, errorMsg, name) => {
    try {
        const { data } = await faradayApi.delete('/startupValoration', { data: { id } });
    
            data.data !== 0 && !data.error  ?
                Swal.fire({
                    confirmButtonColor: '#001B60',
                    text: `${name} ${succesMsg}`,
                    icon: "success",
                })
                :
                Swal.fire({
                    confirmButtonColor: '#001B60',
                    text: errorMsg,
                    icon: "error",
                })       
        
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })  
    }
}

export const editStartupValoration = async (formValues, succesMsg, errorMsg) => {

    try {
        const { data } = await faradayApi.put('/startupValoration', formValues)
        if (!data.error) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
        }
        return false
}